import React from 'react'
import Style from './IncidentFeed.module.css'

// Shared "Coming Soon" placeholder (D-9, PIXMC-6521).
//
// Everything the wireframe shows is present from day one; anything this story does not
// implement renders this rather than being absent. Each variant keeps the SAME FOOTPRINT
// as the real thing it stands in for, so nothing reflows when a sibling story swaps one
// out — that is the whole point of a shared component rather than per-site markup.
//
// `PolicyViolations.jsx` carries a different, older "Not enabled" idiom for its own
// sub-tabs. Per Q-10 that stays where it is; this screen uses "Coming Soon" and the
// portal carries both until they are reconciled separately.
const VARIANT_CLASS = {
  // Stands in for a ring stat card in the Overview's stat row.
  statCard: Style.comingSoonStatCard,
  // Stands in for one of the three Daily activity trend panels.
  panel: Style.comingSoonPanel,
  // Stands in for a whole card body (Highest risk users) or a whole tab.
  section: Style.comingSoonSection,
}

const ComingSoon = ({ label, note, variant = 'section', ticket }) => (
  <div className={`${Style.comingSoon} ${VARIANT_CLASS[variant] || VARIANT_CLASS.section}`}>
    <div className={Style.comingSoonInner}>
      {label && <div className={Style.comingSoonLabel}>{label}</div>}
      <div className={Style.comingSoonBadge}>Coming Soon</div>
      {note && <div className={Style.comingSoonNote}>{note}</div>}
      {/* Rendered as a title rather than visible text: useful when triaging a screenshot,
          not something a customer admin should be reading off the page. */}
      {ticket && <span className={Style.srOnly} title={ticket}>{ticket}</span>}
    </div>
  </div>
)

export default ComingSoon
